export const ROUTES = {
    DEFAULT: '/',
    VEHICLE: 'vehicle',
    VEHICLE_BY_VIN: 'vehicle/:vin?',
    SIMULATIONS: 'simulations',
    SIMULATIONS_V1: 'simulations/v1',
    SIMULATIONS_V2: 'simulations/v2',
    SIMULATIONS_DOMAIN: 'simulations/domain',
    SIMULATIONS_ROUTE_BUILDER: 'simulations/route-builder',
    SETTINGS: 'settings',
    ERROR: 'error',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
